import { isString } from 'lodash';

export default function parseDoctorLocationIds(doctorLocationIds) {
    if (isString(doctorLocationIds)) {
        doctorLocationIds = [doctorLocationIds];
    }

    return doctorLocationIds.filter(doctorLocationId =>
        isString(doctorLocationId) && doctorLocationId.trim().length > 0);
}
